import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import CustomerList from '../components/Customers/CustomerList';
import EditCustomer from '../components/Customers/EditCustomer';
import ViewCustomer from '../components/Customers/ViewCustomer';

const Customers = () => {
  return (
    <Routes>
      <Route path="/" element={<CustomerList />} />
      <Route path="/edit/:id" element={<EditCustomer />} />
      <Route path="/edit" element={<EditCustomer />} />
      <Route path="/view/:id" element={<ViewCustomer />} />
    </Routes>
  )
}

export default Customers;